import { render } from "./NoteAttachmentList.vue?vue&type=template&id=0f59e2f2&scoped=true"
import script from "./NoteAttachmentList.vue?vue&type=script&lang=js"
export * from "./NoteAttachmentList.vue?vue&type=script&lang=js"

import "./NoteAttachmentList.vue?vue&type=style&index=0&id=0f59e2f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f59e2f2"]])

export default __exports__